import pageTabs from '@src/views/shared/pageTabs/store';
import paymentWait from '@pages/order/paymentWait/store';
import claim from '@pages/order/claim/store';
import delivery from '@pages/order/shipping/store';
import newOrder from '@pages/order/newOrder/store';
import shipment from '@pages/order/shipment/store';
import marketProducts from '@pages/market/marketProducts/store';
import csList from '@pages/cs/csList/store';
import revenueStatistics from '@pages/statistics/revenueStatistics/store';
import settingMarket from '@pages/settings/market/store';
import settingCarrier from '@pages/settings/carrier/store';
import settingOrderLog from '@pages/settings/orderLog/store';
import settingWorkLog from '@pages/settings/workLog/store';
import settingUsers from '@pages/settings/users/store';
import settingConfig from '@pages/settings/config/store';

import auth from '@pages/auth/store';

import app from '@store/app';
import common from '@store/common';

import navbar from './navbar';
import layout from './layout';

const rootReducer = {
  app,
  common,
  auth,
  navbar,
  layout,
  pageTabs,
  paymentWait,
  claim,
  delivery,
  newOrder,
  shipment,
  marketProducts,
  csList,
  revenueStatistics,
  settingMarket,
  settingCarrier,
  settingOrderLog,
  settingWorkLog,
  settingUsers,
  settingConfig,
};

export default rootReducer;
